// extracted by mini-css-extract-plugin
export default {"layout":"layout___f5mkt","header":"header___GpBoF","subheader":"subheader___BXF1I","description":"description___Dg4Bd","upgradeContainer":"upgradeContainer___i1gHu"};